import React from 'react'
import { Helmet } from 'react-helmet'
import ServicesSection from '../../components/ServicesSection'
import about from "../../assets/about.png"
import Layout from '../../components/layouts/Layout'
import ClientsSection from '../../components/ClientsSection'
import YouTubeAutoPlayGrid from '../../components/YouTubeGridAutoPlay'
import Testimonial from '../../components/Testmonial'

function OurWork() {
  return (
       <div>
            <div>
                <Helmet> <title>Kaanshi Films Entertainment (KFE) | Film & Video Production House Mumbai | Our Work Page</title> </Helmet>
                <Layout>
                    <div className="">
                        <img src={about} height={200} className='h-[500px] w-full  object-fill' alt="" />
                    </div>

                    <ClientsSection/>
                    <Testimonial/>

                    
                    <YouTubeAutoPlayGrid />

                </Layout>
            </div>
        </div>
  )
}

export default OurWork

